let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ds3ow")).then(() => parcelRequire('hYsef'));